import React from "react";

import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Box, Divider, Grid, Typography } from "@material-ui/core";
import { getDisplayAmount } from "./ManageSubscriptionForm";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    productText: {
      color: theme.palette.dark.main,
      display: "flex",
      fontWeight: "bold",
      fontSize: "0.9rem",
      justifyContent: "left",
      height: "18px",
    },
    subtextRight: {
      color: theme.palette.dark.main,
      fontSize: "0.85rem",
      display: "flex",
      justifyContent: "right",
    },
    subtextLeft: {
      color: theme.palette.dark.main,
      fontSize: "0.85rem",
      height: "25px",
    },
    totalAmount: {
      color: theme.palette.dark.main,
      display: "flex",
      fontWeight: "bold",
      fontSize: "0.9rem",
      justifyContent: "right",
    },
    itemDividerBox: {
      marginBottom: "15px",
    },
    planUpdateBox: {
      width: "80%",
    },
  })
);

export default function ProrationItemLayout(props: IProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    currentAmount,
    currentQuantity,
    newAmount,
    newQuantity,
    baseAmount,
    productID,
    country,
  } = props;

  if (currentQuantity === newQuantity) {
    return <div></div>;
  }

  return (
    <Box className={classes.planUpdateBox}>
      <Grid container>
        <Grid item xs={8}>
          <Typography className={classes.productText}>
            {props.productData[productID]} {t("gateways")}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography className={classes.totalAmount}>
            {getDisplayAmount((currentAmount + newAmount) / 100, country)}
          </Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={8}>
          <Typography className={classes.subtextLeft}>
            {t("quantity")} {currentQuantity + " -> " + newQuantity}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography className={classes.subtextRight}>
            {getDisplayAmount(baseAmount / 100, country)} {t("each_short")}
          </Typography>
        </Grid>
      </Grid>
      <Box className={classes.itemDividerBox}>
        <Divider />
      </Box>
    </Box>
  );
}

interface IProps {
  id: string;
  currentQuantity: number;
  currentAmount: number;
  newQuantity: number;
  newAmount: number;
  baseAmount: number;
  productID: string;
  productData: { [key: string]: string };
  country: string;
}
